import React from 'react';
import { IIconProps } from './utils';

export const Observe = ({
  fill = 'currentColor', height = 20, width = 28, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 28 20"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      clipRule="evenodd"
      d="M11.2548 3.4495C12.1081 3.23226 13.0227 3.10712 13.9999 3.10712C19.4234 3.10712 23.0638 6.99722 24.711 9.26106C25.0487 9.72516 25.0487 10.2752 24.711 10.7393C23.0637 13.003 19.4234 16.8929 13.9999 16.8929C8.57653 16.8929 4.93616 13.003 3.28893 10.7393L2.29478 11.4627L3.28893 10.7393C2.95122 10.2752 2.95122 9.72516 3.28891 9.26105C3.65803 8.75377 4.14045 8.1472 4.7331 7.51532C5.20537 7.01179 5.18003 6.22074 4.67649 5.74846C4.17295 5.27619 3.3819 5.30154 2.90963 5.80507C2.2352 6.52415 1.68738 7.21298 1.26741 7.79016C0.291703 9.13111 0.291722 10.8693 1.26747 12.2102C3.03517 14.6395 7.32628 19.3929 13.9999 19.3929C20.6736 19.3929 24.9647 14.6395 26.7324 12.2102C27.7082 10.8693 27.7082 9.13111 26.7325 7.79016C24.9648 5.3608 20.6737 0.607117 13.9999 0.607117C12.8067 0.607117 11.6849 0.760237 10.638 1.02678C9.96896 1.1971 9.56469 1.87751 9.73501 2.54653C9.90533 3.21555 10.5857 3.61982 11.2548 3.4495ZM10.9464 9.99997C10.4765 9.99997 10.0314 9.89384 9.63381 9.70426C9.40255 9.594 9.11422 9.73329 9.11422 9.99997C9.11422 12.6983 11.3016 14.8857 13.9999 14.8857C16.6983 14.8857 18.8857 12.6983 18.8857 9.99997C18.8857 7.30166 16.6983 5.11425 13.9999 5.11425C13.742 5.11425 13.6099 5.428 13.7221 5.67189C13.9005 6.05977 13.9999 6.49147 13.9999 6.94639C13.9999 8.63283 12.6328 9.99997 10.9464 9.99997Z"
      fill={fill}
      fillRule="evenodd"
    />
  </svg>
);
